import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RecruiterService } from '@app/services/recruiterService';
import { DialogModule } from 'primeng/dialog';
import { Job } from '@app/model/job';
import { JobComment } from '@app/model/jobComment';
import { User } from '@app/model/user';
import { JobRecruiterMappingService } from '@app/services/jobRecruiterMapping.service';
import { JobRecruiter } from '@app/model/jobRecruiterMapping';
import { MessageService, SelectItem } from 'primeng/api';
import { NgForm, ReactiveFormsModule } from '@angular/forms';
import { Messages } from '@app/constants/constant';
import { QueryOptions } from '@app/model/query-options';
import { Router, NavigationEnd } from '@angular/router';
import { MultiSelectModule, MultiSelect } from 'primeng/multiselect';
import { stringify } from 'querystring';
import { JobRecruiterMappingServiceGet } from '@app/services/jobRecruiterMapping.serviceGet';
import { AuthenticationService } from '@app/services/authentication.service';
import { LazyLoadEvent, MenuItem, SortEvent } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { ViewScheduledInterviewService } from '@app/services/viewScheduledInterview.service';


@Component({
  selector: 'app-assign-recruiter-form',
  templateUrl: './assign-recruiter-form.component.html',
  styleUrls: ['./assign-recruiter-form.component.css']
})
export class AssignRecruiterFormComponent implements OnInit {
  //Block listing Variable
  JdName: String;
  NoOfPositions: number;
  pendingPositions: number;
  offer:any;
  joining:any;
  joinedPositions:any;
  offeredPositions:any;
  holdPositions:any;
  scheduledPositions:any;
  yetToBeAssigned:any = 0;
  maxPosition:any = 0;
  recordId: String;
  showCloseIcon: false;
  oldJobRecruiter: JobRecruiter;
  records: JobRecruiter;
  first: number = 0;
  pageSize: number = 500;
  options: SelectItem[];

  @Input() display: boolean;
  @Input() fields: Job;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Output() reloadTable = new EventEmitter<boolean>();
  @ViewChild('assignRecruiterForm', { static: false }) public assignRecruiterForm: NgForm;

  showForm: boolean = false;
  isEdit: boolean = false;
  isSwitch: boolean = false; //is switch is now used for closing a recruiter

  // Assign Recruiter Form variables
  formHeader: String = "Recruiter Listing";
  // showErrorMessage = false;
  validRecruiter = true;
  validRecruiterSLA = true;
  validPosition = true;
  offerDate: any;
  joiningDate: any;
  hiringManager: any = "";
  noOfPosition: number;
  startDate: any = new Date();
  comment: String;

  // DataTable variables
  columns = [
    { field: 'jobDescription', header: 'Recruiter Name', sort:{required: true,sortBy:'jobDescription.name'}, width:"20%" },
    { field: 'technology',  header: 'Positions', sort:{required: true,sortBy:'technology.name'}, width:"12%" },
    { field: 'createdOn', header: 'Start Date', type: 'date', sort:{required: true,sortBy:'createdOn'}, width:"12%"  },
    { field: 'createdOn', header: 'End Date', type: 'date', sort:{required: true,sortBy:'createdOn', width:"12%"}  },
    { field: 'createdOn', header: 'Offer Date', type: 'date', sort:{required: true,sortBy:'createdOn'}, width:"12%" },
    { field: 'createdOn', header: 'Joining Date', type: 'date', sort:{required: true,sortBy:'createdOn'}, width:"12%" },
    { field: '', header: 'Actions' ,sort:{required: false}, params :{type:'Redirect',component: AssignRecruiterFormComponent,icon :'pi pi-pencil' }, width:"20%" }

  ];
  // selectedColumns = ["id", "Recruiter", "No. of Positions Assigned", "Start Date", "Offer Date", "Joining Date"];
  selectedColumns = this.columns;
  pageSizeVar = 5;
  loading: boolean = false;
  requiredFieldError:any='';
  constructor(
    private _confirmationService: ConfirmationService,
    private _apiRecruiter: RecruiterService,
    private _JobRecruiterMappingService: JobRecruiterMappingService,
    private _JobRecruiterMappingServiceGet: JobRecruiterMappingServiceGet,
    private _toastService: MessageService,
    private _authenticationService: AuthenticationService,
    public _recruiterService: RecruiterService,
    private _router: Router,
    private _DatePipe: DatePipe,
    private _viewScheduledInterviewService: ViewScheduledInterviewService,

  ) {
  }

  ngDoCheck() {
    if (this.display == true && this.fields != null) {
      this.JdName = this.fields.jobDescription ? this.fields.jobDescription.name : '';
      this.NoOfPositions = this.fields.noOfVacancies;
      this.pendingPositions = this.fields.pendingJobCount;
      this.offer = this.fields.expectedOfferExtendedDate || this.fields.expectedOfferDate;
      this.joining = this.fields.expectedJoiningExtendedDate || this.fields.expectedJoiningDate;
    }
  }

  ngOnInit() {
    let queryParams = this.queryParams();
    queryParams["sortParam"] = { sortField: "name", sortOrder: 1 };
    queryParams["pageParam"] = {
      page:
        this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
      size: this.pageSize
    };
    let dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap(); // for passing request params. this is the job id

    //This code block is to set endpoint in api.service
    this._apiRecruiter.list(queryParams, Messages.endpoint.RecruiterList).subscribe(
      res => {
        this.options = res;   
      });

    this.getAllAssignedRecruiters();
    this.getHeaderInfo();
  }

  getHeaderInfo = function() {
    let queryOptions= new QueryOptions({});
    this._viewScheduledInterviewService.get(this.fields.id, queryOptions,'interview/interview-status').subscribe(res => {
         console.log(res)
         for(let i=0;i<res["length"];i++){
           switch (res[i].status) {
              case "Scheduled":
                this.scheduledPositions = res[i].count;
                break;

              case "Offered":
                this.offeredPositions = res[i].count;
                break;

              case "On-hold":
                this.holdPositions = res[i].count;
                break;

              case "Joined":
                this.joinedPositions = res[i].count;
                break;
           
             default:
               break;
           }
         }
         this.yetToBeAssigned = 0;
         for(let i=0;i<this.records["length"];i++){
           if (!this.records[i].deleted) {
            this.yetToBeAssigned += this.records[i].position;
            this.maxPosition += this.records[i].position;
           }
         }
         this.yetToBeAssigned = this.NoOfPositions - this.yetToBeAssigned;
         this.maxPosition =this.NoOfPositions - this.maxPosition;
      });
  }

  getAllAssignedRecruiters = function () {
    let queryParams = new Object();
    let assignRecruitersQueryOption = new QueryOptions(queryParams);
    assignRecruitersQueryOption.queryMap.set('job', this.fields.id);
    assignRecruitersQueryOption.toQueryMap();

    this._JobRecruiterMappingServiceGet.list(assignRecruitersQueryOption).subscribe(res => {
      this.records = res;
    });

  }

  // onChangeRecruiter(event) {
  //   this.hiringManager = event.value.value;
  //   if (event.value.value == null){ 
  //     this.showErrorMessage = true;
  //   }else{
  //     this.showErrorMessage = false;
  //   }
  // }

  fillRecruiterForm(rowData: any) {
    this.hiringManager = this.isSwitch?"":rowData.user? rowData.user.id : "";
    this.offerDate = rowData.expectedOffer || this.offer;
    this.joiningDate = rowData.expectedJoining || this.joining;
    this.startDate = this.isSwitch || !rowData.startDate?new Date():rowData.startDate;
    this.comment = rowData.recruiterComment;
    this.noOfPosition = this.isEdit ? rowData.position: this.yetToBeAssigned>=0?this.yetToBeAssigned:0;
    this.recordId = rowData.id;
    this.maxPosition = this.isEdit ? this.yetToBeAssigned+rowData.position: this.yetToBeAssigned;
  }

  showRecruiterForm = function (value, data?) {
    this.validRecruiter = true;
    this.validRecruiterSLA = true;
    this.validPosition = true;
    this.showForm = true;
    switch (value) {
      case "add":
        this.formHeader = "Assign Recruiter";
        this.isEdit = false;
        this.isSwitch = false;
        this.fillRecruiterForm({});
        break;

      case "edit":
        this.formHeader = "Edit Recruiter";
        this.isEdit = true;
        this.isSwitch = false;
        this.oldJobRecruiter = data;
        this.fillRecruiterForm(data);
        break;

      case "switch":
        this.formHeader = "Close Recruiter";
        this.isEdit = false;
        this.isSwitch = true;
        this.oldJobRecruiter = data;
        this.fillRecruiterForm(data);
        break;
    
      default:
        this.formHeader = "Recruiter Listing";
        this.showForm=false;
        break;
    }
  }

  onLoad(event?: LazyLoadEvent) {
    this.getAllAssignedRecruiters();
    this.getHeaderInfo();
  }

  queryParams() {
    const queryParams = new Object();
    // sort order as number, 1 for asc and -1 for dec
    queryParams['pageParam'] = {
      page:
        this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
      size: this.pageSize,
    };
    queryParams['sortParam'] = { sortField: "firstName", sortOrder: 1 };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
  }

  confirmModal(rowData, softDelete){
    // this.showDialog(false);
    this._confirmationService.confirm({
      header: "Confirmation",
      message: 'This action will remove the recruiter from selected job position, however, associated data (ex. interviews, candidates etc.) are still accessible to other recruiter assigned on this position. Do you want to proceed?',
      accept: () => {
        let endpoint = "delete?id="+rowData.id+"&isDeleted="+softDelete;
        this._JobRecruiterMappingServiceGet.deleteRecruiter("job-recruiter-mapping", endpoint).subscribe(res => {
          this.showToast(true, "Record deleted successfully.");
          this.onLoad();
          },(err) => {
            this.showToast(false, "Some error! Failed to delete record.");
          }
        ); 
        this.showDialog(true); 
        },
      reject: () => {
        this.showDialog(true); 
      }
    });
  }

  deleteJob(rowData: any, softDelete) {
    // http://localhost:8081/api/job-recruiter-mapping/delete?id=6bcc0fe8-8948-48c7-ab58-6dc3c4499ede&isDeleted=true
    if(softDelete || this.confirmModal(rowData, false)){
      let endpoint = "delete?id="+rowData.id+"&isDeleted="+softDelete;
      this._JobRecruiterMappingServiceGet.deleteRecruiter("job-recruiter-mapping", endpoint).subscribe(res => {
        if (!softDelete) {
          this.showToast(true, "Record deleted successfully.");
        }
        this.onLoad();
        },(err) => {
          if (!softDelete) {
            this.showToast(false, "Some error! Failed to delete record.");
          }
        }
      );  
    }
  }

  assignRecruiter = function (assignRecruiterForm) {
    this.reloadTable.emit(false);
    let jobRecruiter = new JobRecruiter();
    jobRecruiter.jobId = this.fields.id;
    jobRecruiter.id = this.recordId;
    jobRecruiter.user = assignRecruiterForm.value.manager;
    jobRecruiter.position = assignRecruiterForm.value.NoOfPosition;
    jobRecruiter.startDate = String(this._DatePipe.transform(assignRecruiterForm.value.assignmentStartDate, 'dd MMM yyyy hh:mm a'));
    jobRecruiter.expectedOffer = String(this._DatePipe.transform(assignRecruiterForm.value.expOfferDate, 'dd MMM yyyy hh:mm a'));
    jobRecruiter.expectedJoining = String(this._DatePipe.transform(assignRecruiterForm.value.expJoiningDate, 'dd MMM yyyy hh:mm a'));
    jobRecruiter.recruiterComment = this.assignRecruiterForm.value.comments;
    jobRecruiter.endDate = null;

    if (this.isSwitch) { 
      this.oldJobRecruiter.endDate = String(this._DatePipe.transform(new Date(), 'dd MMM yyyy hh:mm a'));
      this.oldJobRecruiter.recruiterComment = this.assignRecruiterForm.value.comments;
      return this._JobRecruiterMappingService.editJob(this.oldJobRecruiter).subscribe(
        res => {
          this.deleteJob(this.oldJobRecruiter, true);
          this.showToast(true, "Recruiter closed successfully.");
          this.showRecruiterForm(false);
          this.onLoad();
        },
        err => {
          this.showToast(false, "Some error! Failed to close recruiter.");
        }
      );
    }  
    //Before proceeding to other cases we validate form fields for custom validations.
    if ((this.checkRecruiterValidity(assignRecruiterForm.form.controls.manager) 
      + this.checkPositionsValidity(assignRecruiterForm.form.controls.NoOfPosition)
      + this.checkSLAValidity(assignRecruiterForm.form.controls.expOfferDate, assignRecruiterForm.form.controls.expJoiningDate)
      )!=3) {
      return;
    }

    if (this.isEdit) {
      return this._JobRecruiterMappingService.editJob(jobRecruiter).subscribe(
        res => {
          this.showToast(true, "Record updated successfully.");
          this.showRecruiterForm(false);
          this.onLoad();
        }, (err) => {
          this.showToast(false, "Some error! Failed to update record.");
        }
      ); 
    }

    return this._JobRecruiterMappingService.create(jobRecruiter).subscribe(
      res => {
        this.showToast(true, "Recruiter assigned successfully.");
        this.showRecruiterForm(false);
        this.onLoad();
      }, (err) => {
        this.showToast(false, "Some error! Failed to assign recruiter.");
      }
    );  
    
  }

  showDialog = function (bool: boolean) {
    this.displayFunction.emit(bool);
    this.assignRecruiterForm.reset();
    this.reloadTable.emit(true);
  }

  showToast = function (isSuccess, message?, detail?) {
    this._toastService.add({
      severity: isSuccess?'success':'error',
      summary: message,
      detail: detail
    });
  }

  checkRecruiterValidity(formControl: any){
    for(let i=0; i<this.records["length"];i++){
      if (!this.isEdit && !this.isSwitch && !this.records[i].deleted && this.records[i].user.id==formControl.value.id ) {
        formControl.setErrors({invalid:true})
        this.validRecruiter = false;
        return 0;
      }
    }
    this.validRecruiter = true;
    return 1;
  }

  checkPositionsValidity(formControl: any){
    let upperlimit = this.isEdit?this.oldJobRecruiter.position + this.yetToBeAssigned :this.yetToBeAssigned;
    if (formControl.value!=0 && (formControl.value>upperlimit || formControl.value<0)) {
      formControl.setErrors({invalid:true})
      this.validPosition = false;
      return 0;
    }
    this.validPosition = true;
    return 1;
  }

  checkSLAValidity(formControl1: any, formControl2: any){
    if (new Date(formControl1.value)>new Date(formControl2.value)) {
      // formControl2.setErrors({invalid:true})
      this.validRecruiterSLA = false
      return 0;
    }
    this.validRecruiterSLA = true;
    return 1;
  }

}
